__turbopack_context__.v({
  "pagination-btn": "PaginationButton-module-scss-module__2osnwW__pagination-btn",
});
